// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_41-2";
export var blackBorderOnHover = "_41-7";
export var cell = "_41-6";
export var cellContainer = "_41-3";
export var checked = "_41-8";
export var disabled = "_41-5";
export var featuredIconCellContainer = "_41-9";
export var featuredIconTextContainer = "_41-b";
export var featuredIconWrapper = "_41-a";
export var noBorder = "_41-c";
export var orangeSelectedRow = "_a0-3";
export var overflowableText = "_41-0";
export var overflowableTextContainer = "_41-1";
export var row = "_42-0";
export var rowCheckboxCell = "_41-4";
export var selectableTable = "_a0-2";